import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQualificationSurveyValidation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1012,
			y1: 90.5503,
			x2: 17.1012,
			y2: 105.55,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.3514,
			y1: 93.8307,
			x2: 111.351,
			y2: 113.831,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 122.818,
			y1: 116.7,
			x2: 190.818,
			y2: 86.7001,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 115.112C13.4183 115.112 17 111.53 17 107.112C17 102.694 13.4183 99.1118 8.99999 99.1118C4.58171 99.1118 1 102.694 1 107.112C1 111.53 4.58171 115.112 8.99999 115.112Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 110.112C10.6568 110.112 12 108.769 12 107.112C12 105.455 10.6568 104.112 8.99999 104.112C7.34313 104.112 6 105.455 6 107.112C6 108.769 7.34313 110.112 8.99999 110.112Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 128.112C120.418 128.112 124 124.53 124 120.112C124 115.694 120.418 112.112 116 112.112C111.582 112.112 108 115.694 108 120.112C108 124.53 111.582 128.112 116 128.112Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 123.112C117.657 123.112 119 121.769 119 120.112C119 118.455 117.657 117.112 116 117.112C114.343 117.112 113 118.455 113 120.112C113 121.769 114.343 123.112 116 123.112Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 96.1128C94.4183 96.1128 98 92.5311 98 88.1128C98 83.6945 94.4183 80.1128 90 80.1128C85.5817 80.1128 82 83.6945 82 88.1128C82 92.5311 85.5817 96.1128 90 96.1128Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 91.1128C91.6569 91.1128 93 89.7697 93 88.1128C93 86.4559 91.6569 85.1128 90 85.1128C88.3431 85.1128 87 86.4559 87 88.1128C87 89.7697 88.3431 91.1128 90 91.1128Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 284.607,
			y1: 30.5271,
			x2: 216.176,
			y2: 59.5271,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 339.943,
			y1: 95.6664,
			x2: 394.943,
			y2: 88.6664,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 297.394,
			y1: 32.8949,
			x2: 328.394,
			y2: 88.8949,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 104.113C336.418 104.113 340 100.531 340 96.1128C340 91.6945 336.418 88.1128 332 88.1128C327.582 88.1128 324 91.6945 324 96.1128C324 100.531 327.582 104.113 332 104.113Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 99.1128C333.657 99.1128 335 97.7697 335 96.1128C335 94.4559 333.657 93.1128 332 93.1128C330.343 93.1128 329 94.4559 329 96.1128C329 97.7697 330.343 99.1128 332 99.1128Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 96.1128C407.418 96.1128 411 92.5311 411 88.1128C411 83.6945 407.418 80.1128 403 80.1128C398.582 80.1128 395 83.6945 395 88.1128C395 92.5311 398.582 96.1128 403 96.1128Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 91.1128C404.657 91.1128 406 89.7696 406 88.1128C406 86.4559 404.657 85.1128 403 85.1128C401.343 85.1128 400 86.4559 400 88.1128C400 89.7696 401.343 91.1128 403 91.1128Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 35.1128C296.418 35.1128 300 31.5311 300 27.1128C300 22.6945 296.418 19.1128 292 19.1128C287.582 19.1128 284 22.6945 284 27.1128C284 31.5311 287.582 35.1128 292 35.1128Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 30.1128C293.657 30.1128 295 28.7696 295 27.1128C295 25.4559 293.657 24.1128 292 24.1128C290.343 24.1128 289 25.4559 289 27.1128C289 28.7696 290.343 30.1128 292 30.1128Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M379.3 66.7628C379.3 68.7828 377.67 70.4128 375.65 70.4128C373.63 70.4128 372 68.7828 372 66.7628C372 64.7428 373.63 63.1128 375.65 63.1128C377.67 63.1128 379.3 64.7428 379.3 66.7628Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M167.549 33.5349C174.159 8.84302 199.975 -5.5875 224.622 2.04691C246.89 8.93267 260.386 32.0721 255.401 54.8445C252.41 68.5124 243.622 79.2708 232.278 85.2331C225.97 88.5547 220.275 92.9847 215.895 98.6263C212.721 102.74 210.126 107.078 209.001 111.281L180.142 103.577C181.267 99.3738 181.193 94.3091 180.496 89.1688C179.527 82.0862 176.794 75.4081 172.988 69.3731C166.491 59.0911 164.159 46.2351 167.551 33.5572L167.549 33.5349Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M222.375 7.81323C200.542 1.0504 177.673 13.8334 171.817 35.7063L171.819 35.7261",
			stroke: "#D9DEEB",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.003 44.0474C194.754 45.964 197.316 50.0817 201.562 51.2194C206.87 52.6415 207.272 47.6026 210.81 48.5507C214.348 49.4987 213.946 54.5376 218.369 55.7227C222.792 56.9078 224.963 52.3429 227.617 53.054",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 194.12,
			y1: 39.5388,
			x2: 188.809,
			y2: 107.615,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 229.043,
			y1: 49.0768,
			x2: 198.094,
			y2: 110.287,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.608 136.391L190.453 138.493C193.545 139.31 196.714 137.486 197.554 134.393L178.52 129.301C177.702 132.392 179.527 135.561 182.62 136.401L182.608 136.391Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.882 134.489L178.355 129.262C175.773 128.571 174.24 125.917 174.931 123.335L180.24 103.502L209.104 111.228L203.794 131.061C203.103 133.644 200.449 135.177 197.867 134.485L197.882 134.489Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.164 112.082C174.917 111.641 174.831 111.109 174.97 110.582C175.248 109.529 176.333 108.896 177.398 109.185L208.572 117.519C209.625 117.797 210.258 118.882 209.969 119.947C209.691 121 208.606 121.633 207.541 121.345L176.368 113.01C175.841 112.871 175.423 112.533 175.164 112.082Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.811 120.899C172.564 120.458 172.478 119.926 172.617 119.4C172.895 118.346 173.98 117.713 175.045 118.002L206.218 126.336C207.272 126.615 207.904 127.699 207.616 128.764C207.338 129.818 206.253 130.451 205.188 130.162L174.015 121.828C173.488 121.689 173.07 121.351 172.811 120.899Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 100,
			y: 24.1128,
			width: 38,
			height: 24,
			rx: 8,
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.116 44.8955C124.153 44.3116 124.153 42.914 125.116 42.3301L135.722 35.9002C136.722 35.2942 138 36.014 138 37.183L138 50.0426C138 51.2116 136.722 51.9313 135.722 51.3253L125.116 44.8955Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 110,
			cy: 36.1128,
			r: 2,
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 119,
			cy: 36.1128,
			r: 2,
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 128,
			cy: 36.1128,
			r: 2,
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M40.2999 66.7628C40.2999 68.7828 38.6699 70.4128 36.6499 70.4128C34.6299 70.4128 33 68.7828 33 66.7628C33 64.7428 34.6299 63.1128 36.6499 63.1128C38.6699 63.1128 40.2999 64.7428 40.2999 66.7628Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.057 91.6899C296.776 97.2185 299.938 105.125 294.195 109.985C288.55 114.757 282.569 108.237 279.682 103.664C277.539 100.286 275.789 96.6459 274.526 92.8474C273.703 90.3818 272.838 86.5698 275.306 84.6944C277.425 83.0905 280.222 84.3873 281.723 86.2051C283.886 88.8416 285.573 92.8157 286.257 96.1208C286.88 99.1195 286.413 102.639 284.056 104.822C281.899 106.807 278.739 106.914 276.09 105.943C272.798 104.734 269.436 101.72 267.474 98.8346C266.285 97.0761 265.98 94.4633 268.391 93.5965C271.246 92.5618 273.393 95.1077 274.434 97.4151C275.831 100.538 277.376 104.385 276.513 107.854C275.861 110.49 273.789 112.75 270.936 112.732C268.132 112.716 265.683 110.735 263.748 108.914C262.152 107.404 259.657 104.796 261.12 102.43C262.602 100.04 266.068 101.209 267.241 103.225C269.057 106.339 268.09 110.907 266.859 114.052C265.404 117.776 262.83 120.928 259.517 123.149C259.098 123.428 258.633 122.795 259.058 122.508C263.36 119.621 266.374 115.049 267.166 109.903C267.552 107.437 267.776 103.232 264.878 102.124C263.336 101.534 261.296 102.276 261.49 104.246C261.63 105.632 262.762 106.856 263.701 107.795C265.06 109.152 266.605 110.517 268.368 111.311C271.409 112.703 274.503 111.437 275.582 108.194C276.461 105.548 275.618 102.758 274.691 100.246C273.813 97.8648 272.147 93.0069 268.654 94.3366C264.751 95.8235 269.831 100.419 271.205 101.71C273.219 103.609 275.553 105.367 278.39 105.707C281.393 106.064 284.028 104.619 285.134 101.772C286.253 98.9085 285.582 95.858 284.465 93.1035C283.591 90.9563 282.572 88.4475 281.068 86.6655C280.011 85.4122 278.267 84.324 276.559 84.9102C274.514 85.6102 274.322 88.0268 274.57 89.835C275.262 94.8956 278.235 100.141 281.037 104.31C283.957 108.651 290.134 114.07 294.707 108.303C298.665 103.311 295.747 96.9009 293.311 91.9609C293.085 91.5084 293.83 91.2233 294.049 91.6836L294.057 91.6899Z",
			fill: "#8C94AA"
		})
	]
});
const ForwardRef = forwardRef(SvgQualificationSurveyValidation);
export default ForwardRef;
